import React, {useContext} from "react";
import {LanguageContext} from "../../App";
import classes from "../../styles/component_styles/services.module.scss";
import image from "../../images/services/ShowerPan.jpg";
import {FaShower} from "react-icons/fa";
import {Col, Container, Row} from "react-bootstrap";
import {Helmet} from "react-helmet";

function ShowerpanPage() {

    const languageContext = useContext(LanguageContext);

    return(
        <>

            <Helmet>
                <title>Shower Pan Installation Services in Charlotte NC</title>
                <meta
                    name="description"
                    content="Discover expert shower pan installation services in Charlotte NC. Our skilled team ensures quality installations tailored to your bathroom renovation needs."
                />
            </Helmet>

            <div className={classes.start_image}>
                <h1 className={classes.start_message}><FaShower className={classes.servicesIcon}/> {languageContext.services.ShowerpanPage.title}</h1>
                <p className={classes.darkText}>{languageContext.services.ShowerpanPage.description}</p>
            </div>

            <Container>
                <Row>
                    <Col xl={8} lg={8} md={6} sm={12} xs={12}>
                        <p className={classes.description}>
                            {languageContext.services.ShowerpanPage.text1}
                            <br/><br/>
                            <span>{languageContext.services.ShowerpanPage.text2}</span>
                            <br/>
                            {languageContext.services.ShowerpanPage.text3}
                            <br/><br/>
                            <span>{languageContext.services.ShowerpanPage.text4}</span>
                            <br/>
                            {languageContext.services.ShowerpanPage.text5}
                            <br/><br/>
                            <span>{languageContext.services.ShowerpanPage.text6}</span>
                            <br/>
                            {languageContext.services.ShowerpanPage.text7}
                            <br/><br/>
                            <span>{languageContext.services.ShowerpanPage.text8}</span>
                            <br/>
                            {languageContext.services.ShowerpanPage.text9}
                        </p>
                    </Col>
                    <Col xl={4} lg={4} md={6} sm={12} xs={12}>
                        <img src={image} className={classes.image}/>
                    </Col>
                </Row>
            </Container>
        </>
    );

}

export default ShowerpanPage;